import {useEffect, useState} from "react";
import MembersImport from "../../Components/Members/Import/MembersImport";
import ErrorTable from "../../Components/Members/Import/ErrorTable";
// import {emptyError} from "../../Components/Errors.jsx";

const Import = () => {
    const [loading, setIsLoading] = useState(false);
    const [invalidRecords, setInvalidRecords] = useState([]);
    const [successMessage, setSuccessMessage] = useState([]);
    const [, setValidationDatas] = useState([]);


    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        console.log(successMessage)
    }, [successMessage, invalidRecords])
    return <div className={'mt-5'}>
        <MembersImport setInvalidRecords={setInvalidRecords}
                        invalidRecords={invalidRecords} setSuccessMessage={setSuccessMessage}
                        setValidationDatas={setValidationDatas} loading={loading} setIsLoading={setIsLoading}/>
        <div className={'mt-5'}>
            {invalidRecords.length > 0 && <ErrorTable invalidRecords={invalidRecords}/>}

        </div>
       {/* <div>{
            successMessage.length > 0 && <SuccessTable successMessage={successMessage}/>
        }</div>*/}



    </div>
}

export default Import